import { render, staticRenderFns } from "./ymultiselect.vue?vue&type=template&id=39d7ddf0&scoped=true"
import script from "./ymultiselect.vue?vue&type=script&lang=js"
export * from "./ymultiselect.vue?vue&type=script&lang=js"
import style0 from "./ymultiselect.vue?vue&type=style&index=0&id=39d7ddf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7ddf0",
  null
  
)

export default component.exports